// Cart count badge
document.querySelectorAll('.cart-count').forEach(function(el) {
  el.textContent = window.cartItemCount || 0;
});

// Accordion
function toggleAccordion(trigger) {
  var body = trigger.nextElementSibling;
  var isOpen = body.classList.contains('open');
  document.querySelectorAll('.accordion-body').forEach(function(b) { b.classList.remove('open'); });
  document.querySelectorAll('.accordion-trigger').forEach(function(t) { t.classList.remove('open'); });
  if (!isOpen) { body.classList.add('open'); trigger.classList.add('open'); }
}

// Gallery thumbnail switch
function setImg(thumb, src) {
  var mainImg = document.getElementById('mainImg');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('gallery-thumb--active'); });
  thumb.classList.add('gallery-thumb--active');
}

// Format cents to money string
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Update cart count in all badges
function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(function(el) { el.textContent = count; });
}

// Quick Add (single-variant products on collection/home pages)
function quickAdd(btn, event) {
  event.preventDefault();
  event.stopPropagation();
  var variantId = btn.dataset.variantId;
  if (!variantId) return;
  var origText = btn.textContent;
  btn.textContent = 'ADDING...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.status) {
      btn.textContent = origText;
      return;
    }
    return fetch('/cart.js').then(function(r) { return r.json(); });
  })
  .then(function(cart) {
    if (!cart) return;
    updateCartCount(cart.item_count);
    btn.textContent = 'ADDED ✓';
    setTimeout(function() { btn.textContent = origText; }, 2000);
  })
  .catch(function() { btn.textContent = origText; });
}

// Product page variant selection + AJAX add to cart
(function() {
  var productJsonEl = document.getElementById('product-json');
  if (!productJsonEl) return;

  var productData = JSON.parse(productJsonEl.textContent);
  var variants = productData.variants;
  var options = productData.options;
  var selectedOptions = {};

  // Seed from first available variant
  var initVariant = variants.find(function(v) { return v.available; }) || variants[0];
  options.forEach(function(opt, i) { selectedOptions[i] = initVariant.options[i]; });

  function findVariant() {
    return variants.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
    });
  }

  function applyVariant(variant) {
    if (!variant) return;

    var idInput = document.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;

    var priceEl = document.getElementById('product-price');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    var btn = document.getElementById('add-to-cart-btn');
    if (btn) {
      if (variant.available) {
        btn.textContent = 'ADD TO CART';
        btn.disabled = false;
        btn.className = 'btn btn-primary btn-atc';
      } else {
        btn.textContent = 'SOLD OUT';
        btn.disabled = true;
        btn.className = 'btn-soldout';
      }
    }

    if (variant.featured_image) {
      var mainImg = document.getElementById('mainImg');
      if (mainImg) {
        mainImg.src = variant.featured_image.src;
        // Sync gallery thumbs
        document.querySelectorAll('.gallery-thumb').forEach(function(t) {
          var img = t.querySelector('img');
          if (img && img.src.includes(variant.featured_image.src.split('?')[0].split('/').pop().split('_')[0])) {
            document.querySelectorAll('.gallery-thumb').forEach(function(th) { th.classList.remove('gallery-thumb--active'); });
            t.classList.add('gallery-thumb--active');
          }
        });
      }
    }
  }

  // Color swatch clicks
  document.querySelectorAll('.color-swatch[data-option-index]').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      var idx = parseInt(this.dataset.optionIndex);
      selectedOptions[idx] = this.dataset.value;
      document.querySelectorAll('.color-swatch[data-option-index="' + idx + '"]').forEach(function(s) { s.classList.remove('color-swatch--active'); });
      this.classList.add('color-swatch--active');
      var label = document.getElementById('option-label-' + idx);
      if (label) label.textContent = this.dataset.value;
      applyVariant(findVariant());
    });
  });

  // Size tile clicks
  document.querySelectorAll('.size-tile[data-option-index]').forEach(function(tile) {
    tile.addEventListener('click', function() {
      if (this.disabled) return;
      var idx = parseInt(this.dataset.optionIndex);
      selectedOptions[idx] = this.dataset.value;
      document.querySelectorAll('.size-tile[data-option-index="' + idx + '"]').forEach(function(t) { t.classList.remove('size-tile--active'); });
      this.classList.add('size-tile--active');
      var label = document.getElementById('option-label-' + idx);
      if (label) label.textContent = this.dataset.value;
      applyVariant(findVariant());
    });
  });

  applyVariant(initVariant);

  // AJAX add to cart
  var form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = document.getElementById('add-to-cart-btn');
    if (!btn || btn.disabled) return;

    btn.textContent = 'ADDING...';
    btn.disabled = true;

    var variantId = document.querySelector('input[name="id"]').value;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) {
        btn.textContent = 'ADD TO CART';
        btn.disabled = false;
        return;
      }
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      if (!cart) return;
      updateCartCount(cart.item_count);
      btn.textContent = 'ADDED ✓';
      btn.disabled = false;
      setTimeout(function() { btn.textContent = 'ADD TO CART'; }, 2500);
    })
    .catch(function() {
      btn.textContent = 'ADD TO CART';
      btn.disabled = false;
    });
  });
})();

// ---- Toast notification ----
(function() {
  var toast = document.createElement('div');
  toast.className = 'toast';
  document.body.appendChild(toast);

  function showToast(msg) {
    toast.textContent = msg;
    toast.classList.add('toast--visible');
    setTimeout(function() { toast.classList.remove('toast--visible'); }, 4000);
  }

  // Email signup thank-you
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    showToast('YOU\'RE IN. THANKS FOR SIGNING UP.');
    history.replaceState(null, '', window.location.pathname);
  }
})();

// ---- Policy page styles (injected via JS to bypass CDN cache) ----
(function() {
  if (!document.querySelector('.shopify-policy__body')) return;
  var s = document.createElement('style');
  s.textContent = [
    '.shopify-policy__container{max-width:720px;margin:0 auto;padding:60px 32px 80px}',
    '.shopify-policy__title h1{font-family:"Barlow Condensed",sans-serif!important;font-size:clamp(36px,5vw,72px)!important;font-weight:900!important;letter-spacing:.06em!important;text-transform:uppercase!important;margin-bottom:48px!important;text-align:left!important}',
    '.shopify-policy__body{font-size:15px!important;line-height:1.9!important;color:#888888!important}',
    '.shopify-policy__body h1,.shopify-policy__body h2{font-family:"Barlow Condensed",sans-serif!important;font-size:20px!important;font-weight:900!important;letter-spacing:.08em!important;color:#f0f0f0!important;text-transform:uppercase!important;margin:36px 0 10px!important}',
    '.shopify-policy__body h3{font-family:"Barlow Condensed",sans-serif!important;font-size:14px!important;font-weight:700!important;letter-spacing:.1em!important;color:#c9a84c!important;text-transform:uppercase!important;margin:24px 0 8px!important}',
    '.shopify-policy__body p{margin:0 0 14px!important}',
    '.shopify-policy__body a{color:#c9a84c!important}',
    '.shopify-policy__body ul,.shopify-policy__body ol{padding-left:20px!important;margin:0 0 16px!important}',
    '.shopify-policy__body li{margin-bottom:6px!important}',
    '.shopify-policy__body ul li{list-style:none!important;padding-left:12px!important;position:relative!important}',
    '.shopify-policy__body ul li::before{content:"\\2014"!important;position:absolute!important;left:-8px!important;color:#c9a84c!important;font-weight:700!important}',
    '.shopify-policy__body ol li{list-style:decimal!important}'
  ].join('');
  document.head.appendChild(s);
})();
